import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {SpinnerComponent} from '../spinner/spinner.component';
import {NgClass} from '@angular/common';

export type SaveRevertButtonsStatus = '' | 'edited' | 'submitting' | 'succeeded';

@Component({
  selector: 'motn-save-revert-buttons',
  standalone: true,
  templateUrl: './save-revert-buttons.component.html',
  styleUrls: ['./save-revert-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SpinnerComponent,
    NgClass,
  ],
})
export class SaveRevertButtonsComponent implements OnInit {
  @Input() status: SaveRevertButtonsStatus = '';
  @Input() enableRevert: boolean = true;
  @Input() color: 'indigo' | 'green' = 'indigo';
  @Input() saveButtonText: string = 'Save';
  @Input() small: boolean = true;
  @Output() clickedSave$: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickedRevert$: EventEmitter<any> = new EventEmitter<any>();
  @Output() updatedStatus$: EventEmitter<SaveRevertButtonsStatus> = new EventEmitter<SaveRevertButtonsStatus>();


  get submitting(): boolean {
    return this.status === 'submitting';
  }


  get succeeded(): boolean {
    return this.status === 'succeeded';
  }


  get edited(): boolean {
    return !!['edited', 'submitting', 'succeeded'].find(s => s === this.status);
  }


  constructor() {
  }


  ngOnInit(): void {
  }


  revert() {
    if (this.status === '') {
      return;
    }

    this.clickedRevert$.next(null);
    this.resetStatus();
  }


  save() {
    if (this.status === '') {
      return;
    }

    this.status = 'submitting';
    this.clickedSave$.next(null);
    this.emitStatus();
  }


  private emitStatus() {
    this.updatedStatus$.next(this.status);
  }


  /**
   * Designed for parent component to use if saving failed for some reason
   */
  resetStatus(status: SaveRevertButtonsStatus = '') {
    this.status = status;
    this.emitStatus();
  }


  /**
   * Designed for parent component to use if saving succeeded
   */
  showSavedStatus() {
    this.status = 'succeeded';
    this.emitStatus();

    setTimeout(() => {
      this.status = 'edited';
      this.emitStatus();
    }, 2000);
  }
}
